import { combineReducers } from 'redux';

import loadingArraySlice from 'modules/global/reducers/loadingArraySlice';
import * as types from 'modules/leads/actionTypes';

export default combineReducers({
  assign: loadingArraySlice(types.ASSIGN_REQUEST, { global: {} }),
  delete: loadingArraySlice(types.DELETE_LEAD_REQUEST, { global: {} }),
  setStatus: loadingArraySlice(types.SET_STATUS_REQUEST, { global: {} }),
  createDirectMessage: loadingArraySlice(types.CREATE_DM_REQUEST, { global: {} }),
});
